import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { format, subDays } from "date-fns";
import { th } from "date-fns/locale";
import "./styles/MaintenanceTracker.css";

const formatNumber = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}).format;

const generateChartData = (days) => {
  const currentDate = new Date();
  return Array.from({ length: days }, (_, i) => ({
    date: format(subDays(currentDate, days - 1 - i), "dd MMM", { locale: th }),
    Kwh: Math.floor(Math.random() * 7001),
  }));
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`วันที่ : ${label}`}</p>
        <p className="intro">{`Kwh : ${formatNumber(payload[0].value)}`}</p>
      </div>
    );
  }
  return null;
};

const AreaChartComponent = () => {
  const [chartHeight, setChartHeight] = useState(250);
  const data = useMemo(() => generateChartData(7), []);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setChartHeight(entry.contentRect.height);
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      id="chart-container"
      className="chart-container-AreaChartComponent"
      style={{ height: "80%", width: "100%" , marginTop: "1.5rem"}}
    >
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 10, right: 50, left: 0, bottom: 0 }}
        >
          <CartesianGrid stroke="none" strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            stroke="#FFFFFF"
            axisLine={false}
            tick={{ fill: "#FFFFFF", fontSize: 12, dy: 10 }}
            tickLine
          />
  <YAxis
            ticks={[0, 1000, 2000, 3000, 4000, 5000, 6000, 7000]}
            tickFormatter={formatNumber}
            label={
              <text
                x={30}
                y={15}
                textAnchor="start"
                fill="#FFFFFF"
                fontSize={12} // ปรับขนาดตัวอักษรเป็น 12
              >
                Kwh.
              </text>
            }
            stroke="#FFFFFF"
            tick={{ fill: "#FFFFFF", fontSize: 12 }} // ปรับขนาดตัวอักษรเป็น 12
            orientation="left"
            tickLine={true}
          />
          <Tooltip content={<CustomTooltip />} />
          <defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="50%" stopColor="#E4F1FF" />
              <stop offset="100%" stopColor="rgba(155, 205, 255, 0)" />
            </linearGradient>
          </defs>
          <Area
            type="linear"
            dataKey="Kwh"
            stroke="#2762F8"
            fill="url(#colorGradient)"
            strokeWidth={4}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaChartComponent;
